module.exports = __webpack_public_path__ + "img/loading_dh.9cbb064.gif";